import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  CustomModalProps,
  CustomerConfirm,
} from '../../../../components/ModalUser'
import {
  GET_RED_INVOICE_ENTRY_PAGE,
  ReconcilableParams,
  RedInvoiceEntryItem,
  RedInvoiceEntryParams,
} from '../../../../api/orderManage'
import { SearchItemFilter } from '../../../../components/SearchFilter'
import reducer, {
  initialState,
  resetStateAction,
  setCheckedDataAction,
  setCheckedKeysAction,
  setLoadingAction,
  setOrderDataAction,
  setPaginationAction,
  setSearchParamAction,
} from './reducer'
import { isResponseCodeSuccess } from '../../../../tools/util'
import { OrderType } from '../../reducer'

export interface Props extends Omit<CustomModalProps, 'modalSubmit'> {
  modalConfirm: (selectedRows: RedInvoiceEntryItem[]) => void
  excludeOrderIds: string[]
  originRemovedList: any[]
  type: OrderType
}

const useAddOrderModalHook = (props: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { checkedData, pagination, searchParam } = state
  const { open, excludeOrderIds, originRemovedList, modalConfirm, type } = props

  useEffect(() => {
    if (open) {
      handleOrderListRequest()
    } else {
      dispatch(resetStateAction())
    }
    // eslint-disable-next-line
  }, [open])

  const onChangeCheck = (selectedRowKeys: any, selectedRows: any[]) => {
    dispatch(setCheckedKeysAction(selectedRowKeys))
    dispatch(setCheckedDataAction(selectedRows))
  }

  // 删除
  const onDelete = () => {
    if (!checkedData.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
    })
  }

  // modal提交
  const modalSubmit = () => {
    modalConfirm(checkedData)
  }

  const handleOrderListRequest = async (param?: RedInvoiceEntryParams) => {
    dispatch(setLoadingAction(true))
    let res: any = {}
    res = await GET_RED_INVOICE_ENTRY_PAGE({
      ...pagination,
      ...param,
    })

    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(
        setOrderDataAction(
          originRemovedList.concat(
            resData.content.map((item: any) => ({ ...item, type: 'new' })),
          ),
        ),
      )
      dispatch(
        setPaginationAction({
          ...pagination,
          pageSize: resData.pageSize,
          pageNo: resData.pageNo,
          totalCount: resData.totalCount,
        }),
      )
    }
    dispatch(setLoadingAction(false))
  }

  const handleSearchClick = (value: SearchItemFilter) => {
    dispatch(setSearchParamAction(value))
    handleOrderListRequest({
      ...value,
      pageNo: 1,
    })
  }

  const loadMoreData = () => {
    handleOrderListRequest({
      ...searchParam,
      pageSize: pagination.pageSize + 10,
    })
  }

  return {
    hooksState: state,
    onChangeCheck,
    onDelete,
    modalSubmit,
    handleSearchClick,
    loadMoreData,
  }
}

export default useAddOrderModalHook
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  CustomModalProps,
  CustomerConfirm,
} from '../../../../components/ModalUser'
import {
  GET_RED_INVOICE_ENTRY_PAGE,
  ReconcilableParams,
  RedInvoiceEntryItem,
  RedInvoiceEntryParams,
} from '../../../../api/orderManage'
import { SearchItemFilter } from '../../../../components/SearchFilter'
import reducer, {
  initialState,
  resetStateAction,
  setCheckedDataAction,
  setCheckedKeysAction,
  setLoadingAction,
  setOrderDataAction,
  setPaginationAction,
  setSearchParamAction,
} from './reducer'
import { isResponseCodeSuccess } from '../../../../tools/util'
import { OrderType } from '../../reducer'

export interface Props extends Omit<CustomModalProps, 'modalSubmit'> {
  modalConfirm: (selectedRows: RedInvoiceEntryItem[]) => void
  excludeOrderIds: string[]
  originRemovedList: any[]
  type: OrderType
}

const useAddOrderModalHook = (props: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { checkedData, pagination, searchParam } = state
  const { open, excludeOrderIds, originRemovedList, modalConfirm, type } = props

  useEffect(() => {
    if (open) {
      handleOrderListRequest()
    } else {
      dispatch(resetStateAction())
    }
    // eslint-disable-next-line
  }, [open])

  const onChangeCheck = (selectedRowKeys: any, selectedRows: any[]) => {
    dispatch(setCheckedKeysAction(selectedRowKeys))
    dispatch(setCheckedDataAction(selectedRows))
  }

  // 删除
  const onDelete = () => {
    if (!checkedData.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
    })
  }

  // modal提交
  const modalSubmit = () => {
    modalConfirm(checkedData)
  }

  const handleOrderListRequest = async (param?: RedInvoiceEntryParams) => {
    dispatch(setLoadingAction(true))
    let res: any = {}
    res = await GET_RED_INVOICE_ENTRY_PAGE({
      ...pagination,
      ...param,
    })

    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(
        setOrderDataAction(
          originRemovedList.concat(
            resData.content.map((item: any) => ({ ...item, type: 'new' })),
          ),
        ),
      )
      dispatch(
        setPaginationAction({
          ...pagination,
          pageSize: resData.pageSize,
          pageNo: resData.pageNo,
          totalCount: resData.totalCount,
        }),
      )
    }
    dispatch(setLoadingAction(false))
  }

  const handleSearchClick = (value: SearchItemFilter) => {
    dispatch(setSearchParamAction(value))
    handleOrderListRequest({
      ...value,
      pageNo: 1,
    })
  }

  const loadMoreData = () => {
    handleOrderListRequest({
      ...searchParam,
      pageSize: pagination.pageSize + 10,
    })
  }

  return {
    hooksState: state,
    onChangeCheck,
    onDelete,
    modalSubmit,
    handleSearchClick,
    loadMoreData,
  }
}

export default useAddOrderModalHook
